const FeedxmlIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 3000 3000"
      width={22} height={22}
      {...props}
    >
      <style type="text/css">
        {
          ".kdjfffffeed{fill:#9A3AE6;}.feedkjdkff{fill:#FEDF00;}.feed4442{fill:#FEC600;}"
        }
      </style>
      <g>
        <path
          d="M626.7,1184.5c1-2.4-0.2-5.2-2.6-6c-29.5-10.8-59.5-15.8-89.5-17.6c-30.4-2-50.3,18-65.5,42.3
		c-26.6,42.3-64.7,67-113.6,76.5c-40.7,7.9-72.2-4.2-97.8-35.2c-27.2-32.8-2-93.5,15.8-131.8c46.5-100.3,120.9-172.9,227.9-205.4
		c60.4-18.4,120.4-1.7,178.4,18.2c32.3,11,63.9,23.5,95.5,36.1c10.6,4.2,13.3,3.9,21.1-0.9c193.8-171,428.3-263.3,682.3-293.2
		c162.2-19.1,344-3.2,499.7,47.6c11.9,3.9,14.9,8.4,23.7-0.3c31.4-30.8,93.1-85.1,128.8-111.2c68.3-49.8,142.7-64.4,224.2-41.4
		c57.2,16.1,112,37.5,158.7,75.9c37.5,30.8,59.2,70.6,66.3,118.4c7.4,49.8-20.7,82.7-74.8,88c-43,4.2-83.1-3.7-118.7-29.6
		c-31.5-22.9-82.5-27.8-115.8-4.5c-19.1,13.4-26.5,26.5-37.4,42.9c-1.6,2.5-2.5,5.2-0.8,7.5l37.6,39.5c5.8,5.7,5.8,5.7,16.9,2.3
		c58.1-18,160.3-35.4,221.3-29.6c110.9,10.4,212.9,47.7,304.2,110.9c48.6,33.6,82.6,68.2,87,125.9c4.1,53.9-35.7,99.4-90.3,99.6
		c-40.8,0.2-79-13.4-116-29.3c-40.4-17.4-123.8-48.6-167.2-57.4c-55.3-11.3-73.3-0.7-127.9,3.3c-7.8,0.6-10,1.7-8.5,7.6
		c1.8,7.3,14.1,52.6,13.8,68.9c-0.1,3.7,0.5,5.1,9.5,5.8c60.6,5,113.6,46.4,156.8,84.9c80.6,71.8,120.4,165.6,143.5,268.3
		c10.3,45.8,21,91.6,25.6,138.6c2.8,29.2,4.4,58.5-4.1,86.1c-14.8,48.1-24.4,61.4-70.9,73.3c-39.3,10.1-100.3-18.4-119.7-52.6
		c-20.6-36.3-27.1-76.8-35.7-116.8c-11.6-53.9-29.4-98.6-63.4-142.7c-28.1-36.5-73.6-50.5-114.1-68.8c-7.4-3.3-8-4.1-12.1,3
		c-17.7,31.1-43.7,64.9-66.2,92.7c-7.3,9.1-6.9,10.9-1.8,15.1c27.6,22.6,60,50.4,82.9,78.2c104.1,126.6,118.4,336,32.5,475.1
		c-24.5,39.8-60.5,63.7-104.7,75c-47.7,12.2-95.1-28-100-83.6c-2-22.1-0.7-44.1,5.8-65.5c29-97.3-11.5-235-113.4-307.9
		c-6.7-4.8-9.1-4.9-17,0.2c-127.1,81.4-270.6,136.9-417.7,167.5c-149.4,31-302,38.8-453.3,12.9c-16.4-2.8-18.3-4.1-25.8,10.8
		c-58,113.6-50.6,226.5,24,328.4c26.1,35.6,37.7,74.3,23.7,117.8c-9.1,27.9-29.2,44.7-57.8,48.5c-48.5,6.5-92.9-2.9-133-33.8
		c-156.7-120.7-189.9-371.1-111.2-528.7c9.9-19.9,7.6-24.4-12.8-36.8c-20.2-12.2-59.4-35.1-78-49.3c-11.5-8.8-11.8-6.6-22.5,0.7
		c-54.6,37.1-78.5,93.3-82.1,156.3c-2.8,49.9,5.8,98.3,15.6,146.7c5.1,25.3,7.5,50.9,3.8,77.1c-6.1,43.5-18.3,85.4-57.8,96.1
		c-44,11.9-93.2-6.9-124-45.6c-30.1-37.7-43.8-82.7-53.3-129c-16.7-81.2-33.9-162.6-25.7-246.1c8.9-89.6,43.1-169.9,98.6-240.9
		c12.4-15.8,37.5-31.4,54.2-42c6.3-4.1,7.4-3.9,4.7-13.8c-1.9-7.1-3.2-13.3-5.3-20.6c-1.5-5.5-2.8-7.8-13.8-8.1
		c-93.1-1.7-174.3,39.5-235,105.3c-25.8,28-52.5,55.2-84,76.8c-31.5,21.5-65.5,39.6-103.9,21c-36.2-17.4-58.9-50.6-63.8-85.3
		c-7.7-54.9,25.9-108.5,60.2-151.4c87.9-110.2,189.5-201.4,332.7-232.7c30.4-6.6,68.9-17.7,99.8-20.6c8.5-0.8,12.2-3.2,15.5-13.5
		C612.9,1216.4,621.4,1196.8,626.7,1184.5z"
        />
        <path
          className="kdjfffffeed"
          d="M1551.4,1707.8c-32.1-2.6-68.4-14.2-90.3-53c-12.4-21.8-9.8-41.3,7-52.5c16.8-11.1,37.4-6.7,50.4,14.6
		c14.1,23.4,51,28.9,76.4,11.3c9.8-6.8,13.2-17.1,14.7-29.3c3.3-27.1,20.2-41.7,41.4-38.5c20.1,3.1,29.5,19.8,26.8,47.4
		C1671.6,1668.9,1625.8,1708,1551.4,1707.8z"
        />
        <g>
          <path
            className="feedkjdkff"
            d="M2182.5,976.9L1826,1594.3c10,0.8,20.3,1,31,0.4c104.4-2.5,200.4-31.8,285.3-92.9
			c38.1-27.4,64-65.8,73.8-111.9c24-112.7,27.3-226.2,4.7-339.5C2215.4,1022.3,2206,995.1,2182.5,976.9z"
          />
          <path
            className="feed4442"
            d="M1299.3,1111.7c-109-4.5-214.4,17.8-318.4,47.4c-62.5,17.8-126.2,33.6-183.5,65.6
			c-44.4,24.9-60.9,61-51.9,110.7c19.8,109,64.4,207.8,122.8,301.3c38,60.8,90.2,92.2,153.1,103.4l358.7-621.2
			C1353.2,1116.3,1326.3,1112.9,1299.3,1111.7z"
          />
          <path
            className="feed4442"
            d="M2171.6,969.7L2171.6,969.7L2171.6,969.7c-29.2-17.9-62.2-18-94.4-16.4c-85.5,4.1-170.5,13.8-254.5,30.6
			c-40.7,8.1-95.4,21.9-144.9,39.3l-179,310c4.5-2.1,9.8-3.4,15.9-3.8l0,0l0,0c17.4-2.7,30.5,4.4,42,17.2
			c16.4,18.2,28.8,39,40.1,60.5c15.9,30.3,34.1,59.3,57.1,84.7c47.8,52.6,100.5,96.3,172,102.7L2182.4,977
			C2179.2,974.2,2175.6,971.9,2171.6,969.7z"
          />
          <path
            className="feedkjdkff"
            d="M1598.8,1058c-65,37.9-131.8,72.3-211.3,61.8l0,0l0,0c-2.5-0.2-5-0.5-7.5-0.8l-358.7,621.2
			c17.4,3.1,35.6,4.6,54.5,4.8c42,3.5,83.4-2.5,124.7-8.6c27.3-4,52.7-10.2,76.3-18.9c73.8-27.2,128.5-78.7,157.8-163.2
			c8.7-25.1,15.8-50.5,20.7-76.7c5.7-30,5.9-60.8,12.4-90.7c1.5-7.2,3.5-14.2,5.8-21.3c5.1-14.8,12.4-26.7,25.3-32.5l179-310
			C1648.3,1033.5,1620.6,1045.3,1598.8,1058z"
          />
        </g>
      </g>
    </svg>
  );
};

export default FeedxmlIcon;
